"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovModule = void 0;
const proposal_1 = require("../codec/coin/proposal");
const distribution_1 = require("../codec/cosmos/distribution/v1beta1/distribution");
const gov_1 = require("../codec/cosmos/gov/v1beta1/gov");
const tx_1 = require("../codec/cosmos/gov/v1beta1/tx");
const params_1 = require("../codec/cosmos/params/v1beta1/params");
const upgrade_1 = require("../codec/cosmos/upgrade/v1beta1/upgrade");
const proposal_2 = require("../codec/fee/proposal");
const proposal_3 = require("../codec/liquiditypool/proposal");
const proposal_4 = require("../codec/market/proposal");
const proposal_5 = require("../codec/oracle/proposal");
const proposal_6 = require("../codec/pricing/proposal");
const util_1 = require("../util");
const amino_1 = require("@cosmjs/amino");
const long_1 = __importDefault(require("long"));
const admin_1 = require("./admin");
const base_1 = __importDefault(require("./base"));
const market_1 = require("./market");
class GovModule extends base_1.default {
    submit(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const { typeUrl, value } = params.content;
            params.content.value = this.encode(typeUrl, value);
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSubmitProposal,
                value: params,
            }, opts);
        });
    }
    deposit(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgDeposit.fromPartial({
                proposalId: new long_1.default(params.proposalId),
                depositor: wallet.bech32Address,
                amount: (0, amino_1.coins)(params.amount, params.denom)
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgDeposit,
                value,
            }, opts);
        });
    }
    vote(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgVote.fromPartial({
                proposalId: new long_1.default(params.proposalId),
                voter: wallet.bech32Address,
                option: params.option,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgVote,
                value,
            }, opts);
        });
    }
    encode(proposalUrl, proposalMsg) {
        const wallet = this.getWallet();
        const { title, description, msg } = proposalMsg;
        switch (proposalUrl.split(".").pop()) {
            case "CreateTokenProposal":
                const createTokenMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromCreateTokenParams)(msg, wallet.bech32Address)
                };
                return proposal_1.CreateTokenProposal.encode(createTokenMsg).finish();
            case "SetMsgGasCostProposal":
                const setMsgGasCostMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromSetMsgGasCostParams)(msg)
                };
                return proposal_2.SetMsgGasCostProposal.encode(setMsgGasCostMsg).finish();
            case "SetMinGasPriceProposal":
                const setMinGasPriceMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromSetMinGasPriceParams)(msg)
                };
                return proposal_2.SetMinGasPriceProposal.encode(setMinGasPriceMsg).finish();
            case "RemoveMsgGasCostProposal":
                const removeMsgGasCostMsg = {
                    title: title,
                    description: description,
                    msgType: proposalMsg.msgType,
                };
                return proposal_2.RemoveMsgGasCostProposal.encode(removeMsgGasCostMsg).finish();
            case "RemoveMinGasPriceProposal":
                const removeMinGasPriceMsg = {
                    title: title,
                    description: description,
                    denom: proposalMsg.denom,
                };
                return proposal_2.RemoveMinGasPriceProposal.encode(removeMinGasPriceMsg).finish();
            case "LinkPoolProposal":
                const linkPoolMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromLinkPoolParams)(msg)
                };
                return proposal_3.LinkPoolProposal.encode(linkPoolMsg).finish();
            case "UnlinkPoolProposal":
                const unlinkPoolMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromUnlinkPoolParams)(msg)
                };
                return proposal_3.UnlinkPoolProposal.encode(unlinkPoolMsg).finish();
            case "SetRewardCurveProposal":
                const setRewardCurveMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromSetRewardCurveParams)(msg)
                };
                return proposal_3.SetRewardCurveProposal.encode(setRewardCurveMsg).finish();
            case "SetCommitmentCurveProposal":
                const setCommitmentCurveMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromSetCommitmentCurveParams)(msg)
                };
                return proposal_3.SetCommitmentCurveProposal.encode(setCommitmentCurveMsg).finish();
            case "SetRewardsWeightsProposal":
                const setRewardsWeightsMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromSetRewardsWeightsParams)(msg)
                };
                return proposal_3.SetRewardsWeightsProposal.encode(setRewardsWeightsMsg).finish();
            case "UpdatePoolProposal":
                const updatePoolProposalMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromUpdatePoolParams)(msg)
                };
                return proposal_3.UpdatePoolProposal.encode(updatePoolProposalMsg).finish();
            case "UpdateMarketProposal":
                const updateMarketProposalMsg = {
                    title: title,
                    description: description,
                    msg: (0, market_1.transfromUpdateMarketParams)(msg)
                };
                return proposal_4.UpdateMarketProposal.encode(updateMarketProposalMsg).finish();
            case "CreateOracleProposal":
                const createOracleProposalMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transfromCreateOracleParams)(msg, wallet.bech32Address)
                };
                return proposal_5.CreateOracleProposal.encode(createOracleProposalMsg).finish();
            case "SettlementPriceProposal":
                const settlementPriceProposalMsg = {
                    title: title,
                    description: description,
                    msg: (0, admin_1.transformSetSettlementPriceParams)(msg),
                };
                return proposal_6.SettlementPriceProposal.encode(settlementPriceProposalMsg).finish();
            case "ParameterChangeProposal":
                const parameterChangeProposalMsg = {
                    title: title,
                    description: description,
                    changes: proposalMsg.changes,
                };
                return params_1.ParameterChangeProposal.encode(parameterChangeProposalMsg).finish();
            case "SoftwareUpgradeProposal":
                const softwareUpgradeProposalMsg = {
                    title: title,
                    description: description,
                    plan: proposalMsg.plan,
                };
                return upgrade_1.SoftwareUpgradeProposal.encode(softwareUpgradeProposalMsg).finish();
            case "CommunityPoolSpendProposal":
                const communityPoolSpendProposalMsg = {
                    title: title,
                    description: description,
                    recipient: proposalMsg.recipient,
                    amount: (0, admin_1.transformCommunityPoolSpendAmount)(proposalMsg.amount),
                };
                return distribution_1.CommunityPoolSpendProposal.encode(communityPoolSpendProposalMsg).finish();
            case "CancelSoftwareUpgradeProposal":
                const cancelSoftwareUpgradeProposaMsg = {
                    title: title,
                    description: description,
                };
                return upgrade_1.CancelSoftwareUpgradeProposal.encode(cancelSoftwareUpgradeProposaMsg).finish();
            case "TextProposal":
                const textProposalMsg = {
                    title: title,
                    description: description,
                };
                return gov_1.TextProposal.encode(textProposalMsg).finish();
            default:
                return new Uint8Array();
        }
    }
}
exports.GovModule = GovModule;
;
